import { Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import { Button } from "components/atoms/Button";
import { DropDown } from "components/atoms/DropDown";
import "./index.scss";

interface SelectedBtnState {
  [key: string]: boolean;
  "1": boolean;
  "2": boolean;
  "3": boolean;
  "4": boolean;
}

interface IProps {
  selectedBtn: SelectedBtnState;
  setSelectedBtn: Dispatch<SetStateAction<SelectedBtnState>>;
  btnsLabelOrder: string[];
  setDropDownSelection?: Dispatch<SetStateAction<null | string | { [key: number]: string }>>;
  selectedOption?: null | string | { [key: number]: string };
  placeholder?: string;
  hideDropdown?: boolean;
  dropdownData?: string[];
}

export const GuaranteeTopicFocusFilterButtonSection = ({
  selectedBtn,
  setSelectedBtn,
  btnsLabelOrder,
  setDropDownSelection,
  selectedOption,
  placeholder,
  hideDropdown,
  dropdownData
}: IProps) => {
  const handleOnClick = (btnNumber: number) => {
    setSelectedBtn({
      "1": false,
      "2": false,
      "3": false,
      "4": false,
    });
    setSelectedBtn((prevSelectedBtn: SelectedBtnState) => ({
      ...prevSelectedBtn,
      [btnNumber.toString()]: true,
    }));
  };

  return (
    <div className={classNames("dignostic-exam-filter-section-wrapper")}>
      <div className={classNames("dignostic-exam-filter-section")}>
        <Button
          label={btnsLabelOrder[0]}
          type="filter"
          isSelected={selectedBtn["1"]}
          icon={false}
          onClick={() => handleOnClick(1)}
        />
        <Button
          label={btnsLabelOrder[1]}
          type="filter"
          isSelected={selectedBtn["2"]}
          icon={false}
          onClick={() => handleOnClick(2)}
        />
        <Button
          label={btnsLabelOrder[2]}
          type="filter"
          isSelected={selectedBtn["3"]}
          icon={false}
          onClick={() => handleOnClick(3)}
        />
        <Button
          label={btnsLabelOrder[3]}
          type="filter"
          isSelected={selectedBtn["4"]}
          icon={false}
          onClick={() => handleOnClick(4)}
        />
      </div>
      {hideDropdown === true ? null : dropdownData &&
        <div className={classNames("drop-down-section")}>
          <DropDown
            data={dropdownData}
            setDropDownSelection={setDropDownSelection}
            defaultSelected={selectedOption}
            placeholder={placeholder}
          />
        </div>}
    </div>
  );
};
